import React, {useState,useEffect} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
//import VisibilityIcon from '@mui/icons-material/Visibility';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
//import TwitterIcon from '@mui/icons-material/Twitter';
//import InstagramIcon from '@mui/icons-material/Instagram';
//import FacebookIcon from '@mui/icons-material/Facebook';
import CheckIcon from '@mui/icons-material/Check';
import LaunchIcon from '@mui/icons-material/Launch';
import MessageIcon from '@mui/icons-material/Assignment';
import TheaterComedyIcon from '@mui/icons-material/TheaterComedy';
import CopyToClipboard from 'react-copy-to-clipboard';
import ProfileInput from './ProfileInput';
import MultiLines from './MultiLines';
import RowData from './RowData';
import {Inc,Dataset,Owner,OwnerParam,OwnerProfile} from './Inc';
import StoreImg from './StoreImg';
//import RowTable from './RowTable';
import Ajax from './Ajax';
import Loading from './Loading';
import BottomButtons from './BottomButtons';
import Toast from './Toast';
import {Tools} from './Tools';
import Empty from './Empty';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Title from './Title';
import noImageProfile from './imgs/noimage_profile.png';
import {ThreadsIcon,MastodonIcon,MisskeyIcon,TumblrIcon,FacebookIcon,TwitterIcon,InstagramIcon} from './AdditionalIcons';


interface Props {
	owner:Owner,
	param:OwnerParam,
	setOwner(data:any):void,
}

const ProfileDetail = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        profile: Inc.defaultOwnerProfile(),
		isInput: false,
        isLoading:true,
    });
	const [toast,setToast] = useState('');
    const load = ()=>{
		setStates({...states,isLoading:true});
		Ajax.send("profile/get",{},(res:any)=>{
			//console.log(res);
			if( res.ok ){
				setStates({...states,"isLoading":false,"isInput":false,"profile":Inc.convOwnerProfile(res.profile)})
			}
		});
    }	
	const copy = ()=>{
		setToast('クリップボードにURLをコピーしました');
	}
	const dummy = ()=>{
		
	}
	const closeToast = ()=>{
		setToast('');
	}
	const openInput = ()=>{
		setStates({...states,isInput:true});
	}
	const closeInput = (updated:boolean,profile:OwnerProfile,owner:any)=>{
		//console.log("close input");
		if( updated ){
			//console.log("updated");
			//load();
			setStates({...states,"isLoading":false,"isInput":false,"profile":profile});
			if( props.owner.owner_id===0 ){
				props.setOwner(owner)
			}
		} else {
			setStates({...states,isInput:false});
		}
	}

    useEffect( ()=>{
        window.scrollTo(0,0);
        if( props.owner.owner_id>0 ){
			load();
        } else {
            setStates({...states,"isLoading":false});
        }
    } ,[]);

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }

    const toPage = "https://store.retro-biz.com/profile_o" + String(props.owner.owner_id) + ".html";
    const toCustomer = "https://store.retro-biz.com/?mod=customer&act=input&phase=sideb";

    let editCaption = "プロフィールを登録する";
    if( props.owner.owner_id>0 ){
        editCaption = "編集する";
    }

	//let extended = props.param.extended;
	//if( extended!=='' ){
	//	const sp = extended.split(" ");
	//	extended = sp[0];
	//} else {
	//	extended = 'なし';
	//}

	//console.log("owner",props.owner);

	return (
		<div id="profile_detail" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="プロフィール" second="（作家登録）" icon="portrait"/>
                        {(props.owner.owner_id>0 && props.owner.customer.name!=="") ? (
                            <React.Fragment>
                            <div style={{marginBottom:"2em"}}>
                            お客さんがあなたに興味を持つきっかけになるかも知れませんので、文章や画像はいろいろと工夫してみると良いでしょう。<br/>
                            内容を修正したい場合は、「編集する」を押して下さい。<br/>
                            </div>
                            <Hidden mdUp implementation="js">
								<BottomButtons
									button1={editCaption} onClick1={openInput} disabled1={props.owner.customer.customer_id===0} icon1={<TheaterComedyIcon/>}
								/>
                            </Hidden>

							<Divider style={{marginBottom:"1em"}}/>
							<Grid container spacing={1}>
								<Grid item xs={12} sm={3} md={4}>
									<div className={classes.itemDetailLabel}>ヘッダー画像</div>
								</Grid>
								<Grid item xs={12} sm={9} md={8}>
									{states.profile.header_img_id>0 ? (
									<StoreImg owner_id={props.owner.owner_id} img_id={states.profile.header_img_id} className="imgProfileHeader"/>
									):(
									<Empty/>
									)}
								</Grid>
								<Grid item xs={12}>
									<Divider className="formValidator"/>
								</Grid>

								<Grid item xs={12} sm={3} md={4}>
									<div className={classes.itemDetailLabel}>メイン画像</div>
								</Grid>
								<Grid item xs={12} sm={9} md={8}>
									{states.profile.img_id>0 ? (
									<StoreImg owner_id={props.owner.owner_id} img_id={states.profile.img_id} className="imgProfile"/>
									):(
									<img src={noImageProfile} className={classes.imgProfile}/>
									)}
									</Grid>
								<Grid item xs={12}>
									<Divider className="formValidator"/>
								</Grid>

								<Grid item xs={12} sm={3} md={4}>
									<div className={classes.itemDetailLabel}>作家名</div>
								</Grid>
								<Grid item xs={12} sm={9} md={8}>
									{states.profile.owner_name}（{states.profile.kana}）
								</Grid>
								<Grid item xs={12}>
									<Divider className="formValidator"/>
								</Grid>
								<Grid item xs={12} sm={3} md={4}>
									<div className={classes.itemDetailLabel}>団体名</div>
								</Grid>
								<Grid item xs={12} sm={9} md={8}>
									<Empty value={states.profile.company_name}/>
								</Grid>
								<Grid item xs={12}>
									<Divider className="formValidator"/>
								</Grid>
								<Grid item xs={12} sm={3} md={4}>
									<div className={classes.itemDetailLabel}>紹介文</div>
								</Grid>
								<Grid item xs={12} sm={9} md={8}>
									{states.profile.profile!=='' ? (
									<MultiLines text={states.profile.profile}/>
									):(
									<Empty/>
									)}
								</Grid>
								<Grid item xs={12}>
									<Divider className="formValidator"/>
								</Grid>
								<Grid item xs={12} sm={3} md={4}>
									<div className={classes.itemDetailLabel}>SNS</div>
								</Grid>
								<Grid item xs={12} sm={9} md={8}>
									{states.profile.snss.length>0 ? (
									<List dense>
									{states.profile.snss.map((data:Dataset,index:number)=>{
										const key = "sns"+index;
										return (
											<ListItem key={key} style={{padding:"0"}}>
												<ListItemIcon style={{marginRight:"-0.5em",width:"1em",textAlign:'center'}}>
													{data.id==='twitter' && <TwitterIcon/>}
													{data.id==='facebook' && <FacebookIcon/>}
													{data.id==='instagram' && <InstagramIcon/>}
													{data.id==='tumblr' && <TumblrIcon/>}
													{data.id==='mastodon' && <MastodonIcon/>}
													{data.id==='misskey' && <MisskeyIcon/>}
													{data.id==='threads' && <ThreadsIcon/>}
												</ListItemIcon>
												<ListItemText primary={data.id} secondary={data.label!==''?data.label:'なし'} classes={{primary:classes.listItemText,secondary:classes.listItemText}}/>
											</ListItem>
										)
									})}
									</List>
									):(
									<Empty/>
									)}
								</Grid>
								<Grid item xs={12}>
									<Divider className="formValidator"/>
								</Grid>
								<Grid item xs={12} sm={3} md={4}>
									<div className={classes.itemDetailLabel}>リンク</div>
								</Grid>
								<Grid item xs={12} sm={9} md={8}>
										{states.profile.num_links>0 ? (
                                        <List dense>
                                        {states.profile.links.map((data:Dataset,index:number)=>{
                                            const key = "link"+index;
                                            return (
                                                <ListItem key={key} style={{padding:"0"}}>
                                                    <ListItemText primary={data.id} secondary={data.label} classes={{primary:classes.listItemText,secondary:classes.listItemText}}/>
                                                </ListItem>
                                            )
                                        })}
                                        </List>
										):(
										<Empty/>
										)}	
								</Grid>
								<Grid item xs={12}>
									<Divider className="formValidator"/>
								</Grid>
								<Grid item xs={12} sm={3} md={4}>
									<div className={classes.itemDetailLabel}>追加画像</div>
								</Grid>
								<Grid item xs={12} sm={9} md={8}>
									{states.profile.photo_ids.length>0 ? (
									<Grid container spacing={1}>
									{states.profile.photo_ids.map((img_id:number,index:number)=>{
										const key = "img"+index;
										return (
											<Grid item xs={6} sm={4} key={key}>
												<StoreImg key={key} owner_id={props.owner.owner_id} img_id={img_id} className="imgProfilePhoto"/>
											</Grid>
										);
									})}
									</Grid>
									):(
									<Empty/>
									)}
								</Grid>
								<Grid item xs={12}>
									<Divider className="formValidator"/>
								</Grid>
							</Grid>
                            </React.Fragment>
                        ):(
                            <React.Fragment>
                            <div className="firstTalk">
                                <p>架空ストアSideBへようこそ！</p>
                                <p>商品の登録を行うには、あなたの連絡先と、作家として活動する際のプロフィールを登録する必要があります。</p>
                                <p>あとから何度でも修正ができますので、とりあえず簡単に登録を済ませて先へ進みましょう。</p>
                            </div>
                            <div className="steps">
                                <div className="stepList">
                                    <Title text="作家登録に必要な作業" size={2}/>
                                    <div className="stepBox">
                                        <h3>STEP.1　連絡先の登録<span style={{fontSize:"90%"}}>（会員登録）</span></h3>
                                        <div>
                                            まずは住所や氏名などの連絡先を登録して下さい。<br/>
                                            連絡先の登録は商品を購入されるお客様と同じ登録フォームを使用します。</div>
                                        <div className="stepBtn">
                                        {props.owner.customer.name==="" ? (
                                        <a href={toCustomer}><Button variant="contained" color="primary" style={{width:"100%"}}><AccountBoxIcon/>連絡先の登録</Button></a>
                                        ):(
                                        <div className="stepOK"><span className="withIcon"><CheckIcon/>登録済</span></div>
                                        )}
                                        </div>
                                    </div>
                                    <div className="stepArrow">
                                        <ArrowDownwardIcon className={classes.chartDownwardIcon}/>
                                    </div>
                                    <div className="stepBox">
                                        <h3>STEP.2　プロフィールの登録</h3>
                                        <div>
                                            次に作家としてのプロフィールを登録して下さい。<br/>
                                            プロフィールはあとでいつでも変更できますので、とりあえずは仮の内容でも構いません。<br/>
                                        </div>
                                        <div className="stepBtn">
                                        {props.owner.customer.name==="" && props.owner.owner_id===0 && 
                                            <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true} startIcon={<TheaterComedyIcon/>}>{editCaption}</Button>
                                        }
                                        {props.owner.customer.name!=="" && props.owner.owner_id===0 && 
                                            <Button variant="contained" color="primary" style={{width:"100%"}} onClick={openInput} startIcon={<TheaterComedyIcon/>}>{editCaption}</Button>
                                        }
                                        {props.owner.owner_id>0 &&
                                        <div className="stepOK"><span className="withIcon"><CheckIcon/>登録済</span></div>
                                        }
                                        </div>
                                    </div>
                                    <div className="stepArrow">
                                        <ArrowDownwardIcon className={classes.chartDownwardIcon}/>
                                    </div>
                                    <div className="stepBox">
                                        <h3>STEP.3　作家登録完了</h3>
                                        <div>
                                            商品登録などの機能がご利用可能になります。<br/>
                                            ※初めての納品の前には、「事前審査」が必要です。
                                        </div>
                                    </div>
                                </div>
                            </div>


                            </React.Fragment>
                        )}
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
						<RowData name="取り扱い開始日" value={states.profile.start_date}/>
						<RowData name="最終納品日" value={states.profile.last_consign}/>
						<RowData name="最終売上日" value={states.profile.last_sale}/>
						<RowData name="一時停止解除日" value={states.profile.extended}/>
						<div style={{position:"relative",marginTop:'0.5em'}}>
							<div style={{position:"absolute",top:"0",left:"0",width:"40%"}}>状態</div>
							<div style={{marginLeft:"40%",textAlign:"right"}}>
								{Tools.colorLabel("owner_status",props.owner.status,states.profile.status_label)}
							</div>
						</div>
						{props.owner.owner_id>0 &&
						<div>
							<Divider style={{marginTop:'0.5em',marginBottom:'0.5em'}}/>
							<div>プロフィールページのURL</div>
							<div style={{lineHeight:"1.0em",textAlign:"left",marginBottom:'0.5em'}}>
								<input type="text" value={toPage} style={{width:'100%',padding:'0.25em 0.1em',boxSizing:'border-box'}} onChange={dummy}/>
							</div>
							<div style={{textAlign:"left",marginLeft:'-0.5em'}}>
								<a href={toPage} rel="noopener noreferrer" target="_blank"><Button variant="text" size='small' color="primary"><LaunchIcon/> ページを開く</Button></a>
								<CopyToClipboard text={toPage} onCopy={copy}>
									<Button variant="text" color="primary" size="small"><MessageIcon/> URLをコピー</Button>
								</CopyToClipboard>
							</div>
						</div>
                        }

						<Divider style={{margin:"1em 0",marginTop:'0.5em'}}/>
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
                                {props.owner.customer.name!=="" ? (
								<Button variant="contained" color="primary" style={{width:"100%"}} onClick={openInput} startIcon={<TheaterComedyIcon/>}>{editCaption}</Button>
                                ):(
                                <Button variant="contained" color="primary" style={{width:"100%"}} disabled={true} startIcon={<TheaterComedyIcon/>}>{editCaption}</Button>
                                )}
							</FormControl>
						</Hidden>
                        <ul style={{paddingLeft:"1.5em",paddingRight:"0.5em"}}>
                            <li>初めての作家さんは「ご利用ガイド」をご覧下さい</li>
                            <li>プロフィールページは商品の販売が開始されてから公開されます。</li>
                        </ul>
                        <div style={{textAlign:'right'}}>
                            <Link to='/first'><Button variant="text" color="primary" startIcon={<ArrowForwardIcon/>}>ご利用ガイド</Button></Link>
                        </div>
                    </Paper>
                </Grid>
            </Grid>
			<ProfileInput isOpen={states.isInput} owner={props.owner} profile={states.profile} close={closeInput}/>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default ProfileDetail;
